import axios from 'axios'
import { bffBaseURL, normalizeError } from './apiClient'

// ============================================================================
// Clients Entity API — Phase 60 Milestone 9
// ============================================================================

export async function listClientEntities(params: Record<string, any> = {}) {
  try {
    const queryParams = new URLSearchParams()
    if (params.page) queryParams.set('page', params.page)
    if (params.limit) queryParams.set('limit', params.limit)
    if (params.search) queryParams.set('search', params.search)

    const queryString = queryParams.toString()
    const response = await axios.get(
      `${bffBaseURL}/api/v1/clients${queryString ? '?' + queryString : ''}`
    )
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const message = normalizeError((error.response?.data as any)?.detail || 'Failed to list clients')
      throw new Error(message)
    }
    throw error
  }
}

export async function getClientEntity(clientId: string) {
  try {
    const response = await axios.get(
      `${bffBaseURL}/api/v1/clients/${clientId}`
    )
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const message = normalizeError((error.response?.data as any)?.detail || 'Failed to get client')
      throw new Error(message)
    }
    throw error
  }
}

export async function createClientEntity(data: any) {
  try {
    const response = await axios.post(
      `${bffBaseURL}/api/v1/clients`,
      data
    )
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const message = normalizeError((error.response?.data as any)?.detail || 'Failed to create client')
      throw new Error(message)
    }
    throw error
  }
}

export async function updateClientEntity(clientId: string, data: any) {
  try {
    const response = await axios.patch(
      `${bffBaseURL}/api/v1/clients/${clientId}`,
      data
    )
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const message = normalizeError((error.response?.data as any)?.detail || 'Failed to update client')
      throw new Error(message)
    }
    throw error
  }
}

export async function deleteClientEntity(clientId: string) {
  try {
    await axios.delete(
      `${bffBaseURL}/api/v1/clients/${clientId}`
    )
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const message = normalizeError((error.response?.data as any)?.detail || 'Failed to delete client')
      throw new Error(message)
    }
    throw error
  }
}

// ============================================================================
// Client Areas API — Phase 60 Milestone 9
// ============================================================================

export async function listClientAreas(clientId: string) {
  try {
    const response = await axios.get(
      `${bffBaseURL}/api/v1/clients/${clientId}/areas`
    )
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const message = normalizeError((error.response?.data as any)?.detail || 'Failed to list areas')
      throw new Error(message)
    }
    throw error
  }
}

export async function createClientArea(clientId: string, data: any) {
  try {
    const response = await axios.post(
      `${bffBaseURL}/api/v1/clients/${clientId}/areas`,
      data
    )
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const message = normalizeError((error.response?.data as any)?.detail || 'Failed to create area')
      throw new Error(message)
    }
    throw error
  }
}

export async function updateClientArea(clientId: string, areaId: string, data: any) {
  try {
    const response = await axios.patch(
      `${bffBaseURL}/api/v1/clients/${clientId}/areas/${areaId}`,
      data
    )
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const message = normalizeError((error.response?.data as any)?.detail || 'Failed to update area')
      throw new Error(message)
    }
    throw error
  }
}

export async function deleteClientArea(clientId: string, areaId: string) {
  try {
    await axios.delete(
      `${bffBaseURL}/api/v1/clients/${clientId}/areas/${areaId}`
    )
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const message = normalizeError((error.response?.data as any)?.detail || 'Failed to delete area')
      throw new Error(message)
    }
    throw error
  }
}

// ============================================================================
// Client Names (autocomplete) — Phase 57 T56
// Moved from skillsApi (was misplaced in original api.js)
// ============================================================================

export async function getClients(limit: number = 100) {
  try {
    const response = await axios.get(
      `${bffBaseURL}/api/v1/clients`,
      { params: { limit } }
    )
    return response.data
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const message = normalizeError((error.response?.data as any)?.detail || 'Failed to fetch clients')
      throw new Error(message)
    }
    throw error
  }
}
